/* ================================================== */
/*  MOBILE MENU
/* ================================================== */

$(document).ready(function(){

	// Add / remove « open » class
	$('.hamburger').on('click', function(){
		$('body').toggleClass('mobileNav--open');
		$(this).toggleClass('hamburger--open');
	});	

	// Add / remove « open » class
	$('#layout--navigation .nav__li a').on('click', function(){		
		$('body').toggleClass('mobileNav--open');
		$('.hamburger').toggleClass('hamburger--open');
	});

});